module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter Dedication",
    attrs: {
      "id": "rw-frontmatter-Dedication_70539-172485987"
    }
  }, [_c('div', {
    staticClass: "block dedication",
    attrs: {
      "id": "rw-block-dedication_70539-931699422"
    }
  }, [_c('p', {
    staticClass: "ded",
    attrs: {
      "id": "rw-p_70539-259498508"
    }
  }, [_c('span', [_vm._v("To Daniel, Regina, and Autumn Rose, with all of my love.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0f9bee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781455522866_dedication.vue
// module id = 66
// module chunks = 0